<template>
    <div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list :finished="finished" :error.sync="error" finished-text="没有更多了" @load="onLoad" class="consume-list-container">
                <van-cell v-for="(item, index) in consumeLogList" :key="'consume' + index" @click="showDetail(index)">
                    <!-- 使用 title 插槽来自定义标题 -->
                    <template #title>
                        <div class="consume-item-title">{{$store.state.systemEnum['company']['user_card_balance_log']['type'][item.type]}}</div>
                    </template>
                    <template #label>
                        <div class="consume-item-content">
                            <div class="consume-item-type">余额：{{item.balance}}</div>
                        </div>
                    </template>
                    <template #default>
                        <div :class="'consume-item-amount ' + item.income_and_expenditure">{{item.income_and_expenditure === 'income' ? '+' : '-'}}{{item.amount}}</div>
                        <div class="consume-item-date">{{item.created_at | dateFormat('yyyy-MM-dd')}}</div>
                    </template>
                </van-cell>
            </van-list>
        </van-pull-refresh>

        <van-popup v-model="showConsumeDetails" position="bottom" :style="{ height: '60%' }" round>
            <van-cell-group style="margin-top: 1rem;">
                <van-cell title="类型" :value="$store.state.systemEnum['company']['user_card_balance_log']['type'][consumeLogDetailData.type]" />
                <van-cell :title="$store.state.systemEnum['company']['user_card_balance_log']['income_and_expenditure'][consumeLogDetailData.income_and_expenditure]">
                    <div :class="'consume-item-amount ' + consumeLogDetailData.income_and_expenditure">{{consumeLogDetailData.amount}}</div>
                </van-cell>
                <van-cell title="时间" :value="consumeLogDetailData.created_at" />
                <van-cell title="余额" :value="consumeLogDetailData.balance" />
                <van-cell title="备注" :value="consumeLogDetailData.remarks" />
            </van-cell-group>
        </van-popup>
    </div>
</template>

<script>
    import api from '../../assets/js/api'

    export default {
        name: 'ConsumeLog',
        data () {
            return {
                showConsumeDetails: false,
                consumeLogList: [],
                consumeLogDetailIndex: null,
                loading: false,
                finished: false,
                refreshing: false,
                error : false,
                params : {
                    page : 1,
                    page_size : 15,
                },
            }
        },
        computed : {
            consumeLogDetailData(){
                return this.consumeLogDetailIndex !== null ? this.consumeLogList[this.consumeLogDetailIndex] : {};
            },
        },
        methods : {
            onLoad(){
                let self = this;
                if(self.loading) return;

                self.loading = true;
                api.request('/user_card/query_balance_log', Object.assign({}, self.params, {
                    user_card_id: this.$route.query.user_card_id, // 卡片ID
                })).then(res => {
                    if(res.data.length < self.params.page_size){
                        self.finished = true;
                    }else{
                        self.params.page++;
                    }

                    // 如果是刷新就把数据清空
                    if(self.refreshing){
                        self.consumeLogList = [];
                    }

                    for(let index in res.data){
                        self.consumeLogList.push(res.data[index]);
                    }
                }).catch(res => {
                    self.error = true;
                }).finally(() => {
                    self.loading = false;
                    self.refreshing = false;
                });
            },
            onRefresh() {
                this.finished = false;
                this.refreshing = true;
                this.params.page = 1;
                this.onLoad();
            },
            showDetail(index){
                this.showConsumeDetails = true;
                this.consumeLogDetailIndex = index;
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../style/themeify.scss';
    .consume-list-container {
        .van-cell{
            .consume-item-icon {
                border-radius: 50%;
                background: #ed6a0c;
            }
            .consume-item-title {
                font-size: 16px;
            }
        }
    }
    *{
        @include themeify{
            .consume-item-amount{
                &.income{
                    color: themed('colorText');
                }
                &.expenditure{
                    color: black;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/card/ConsumeLog.vue